var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"citylist",on:{"change":function($event){_vm.redirectToCity($event.target.value)}}},_vm._l((_vm.cities),function(city){return _c('option',{key:city.id,domProps:{"value":city.link}},[_vm._v(_vm._s(city.name))])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5271382b","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cities/Selector.vue
// module id = null
// module chunks = 